<template>
  <div>
    <div class="gl_title_bar">
      <div class="gl_tb_left">
        <span class="normaltitle">学分购买</span>
      </div>
    </div>
    <div class="top">
      <img src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Images20210802/learnbanner.png"
           alt="" />
    </div>
    <div class="mid">
      <div class="mtop">
        <div class="mtleft">
          <!-- <span>已购70学分 / </span>
          <span style="color:#0b8586">剩余50学分</span> -->
        </div>
        <div class="mtright">
          <div class="mtrbox"
               style="border-color: #b70109;color: #b70109;"
               @click="pageType = 3"
               v-show="pageType == 1">
            <span>学分卡激活</span>
          </div>
          <div class="mtrbox"
               style="border-color: #b70109;color: #b70109;"
               @click="toList"
               v-show="pageType != 2">
            <span>学分卡记录</span>
          </div>
          <div class=""
               v-show="pageType == 2">
            <el-select v-model="recordType"
                       size="small"
                       @change="recordTypeChange"
                       placeholder="请选择">
              <el-option v-for="item in recordTypeList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="mtrbox"
               @click="pageType = 1"
               v-show="pageType != 1">
            <span>去购卡</span>
          </div>
          <div class="mtrbox"
               @click="pageType = 3"
               v-show="pageType == 2">
            <span>去激活</span>
          </div>
          <div class="mtrbox"
               @click="toCourseList"
               v-show="pageType == 2">
            <span>选课</span>
          </div>
        </div>
      </div>
      <div class="mbox"
           v-show="pageType == 1">
        <div class="courseBox"
             :style="index == 0 ? 'border-top:none' : ''"
             v-for="(item, index) in list"
             :key="index">
          <div class="cleft">
            <div class="imgBox">
              <img :src="item.coverpictureUrl"
                   alt="" />
            </div>
            <div class="infoBox">
              <div class="title">{{ item.cardNum }}</div>
              <div class="remake">
                <div>卡类别：{{ item.scoreType }}</div>
                <div>分值：{{ item.score }}学分</div>
                <!-- <div>使用期限：自购买之日起（730天）有效</div> -->
              </div>
            </div>
          </div>
          <div class="cright">
            <div class="schedules">价格：￥{{ item.cardPrice }}</div>
            <div class="btnArr">
              <div class="statusOne"
                   @click="tobuy(item)">购买</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mbox"
           v-show="pageType == 2">
        <el-table ref="multipleTable"
                  :data="recordList"
                  tooltip-effect="dark"
                  class="mtable"
                  border>
          <el-table-column prop="num"
                           label="卡号"
                           width="120"> </el-table-column>
          <el-table-column prop="scoreType"
                           width="120"
                           label="学分类型"> </el-table-column>
          <el-table-column prop="score"
                           width="60"
                           label="面值"> </el-table-column>
          <el-table-column prop="residueScore"
                           width="80"
                           label="剩余学分"> </el-table-column>
          <el-table-column prop="year"
                           width="60"
                           label="年度"> </el-table-column>
          <!-- <el-table-column prop="issuanceDate"
                           width="160"
                           label="发行时间">
          </el-table-column> -->
          <el-table-column prop="bindDate"
                           width="160"
                           label="购买时间"> </el-table-column>
          <el-table-column prop="expirationTime"
                           width="160"
                           label="过期时间"> </el-table-column>
          <el-table-column width="160"
                           label="使用说明">
            <template slot-scope="scope">{{ scope.row.operation }}</template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="100">
            <template slot-scope="scope">
              <el-button @click="toShowRecord(scope.row)"
                         type="text"
                         size="small">购课记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-if="page.total > page.pageSize"
                    isNum
                    :total="page.total"
                    :limit="page.pageSize"
                    :page="page.currentPage"
                    @page-change="pageChange"></pagination>
      </div>
      <div class="mbox"
           v-show="pageType == 3">
        <div class="active">
          <div>卡号：</div>
          <el-input v-model="active.text"
                    placeholder="请输入卡号"></el-input>
          <div>卡密：</div>
          <el-input v-model="active.word"
                    placeholder="请输入卡密"></el-input>
          <el-button type="primary"
                     @click="toActive"
                     :loading="isActive">激活</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="学分购买"
               width="500px"
               :close-on-click-modal="false"
               :visible.sync="isBuyBox">
      <div class="buybox"
           v-if="payInfo">
        <div class="bbrow">
          <div class="bbtext">分值：</div>
          <div>{{ payInfo.score }}学分</div>
        </div>
        <div class="bbrow">
          <div class="bbtext">购买数量：</div>
          <div>
            <el-input-number size="small"
                             :min="1"
                             :step-strictly="true"
                             v-model="buynum"></el-input-number>
          </div>
        </div>
        <div class="bbrow">
          <div class="bbtext">价格：</div>
          <div>{{ payInfo.cardPrice * buynum }}元</div>
          <div class="el-icon-warning-outline bbtip"
               @click="isShuomingBox = true">学分卡购买说明</div>
        </div>
        <div class="bbrow bbagreement">
          <input type="checkbox"
                 v-model="checked" />
          <div style="margin-left:2px;">
            我已阅读并同意
            <a href="javascript:0"
               style="color:#0b8586"
               @click="isXieyiBox = true">《学分购买协议》</a>
          </div>
        </div>
        <div class="bbrow bbbtn">
          <el-button @click="topay()"
                     :loading="ispaying">支付</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="学分购买协议"
               width="500px"
               :visible.sync="isXieyiBox">
      <div class="xieyiBox">
        <p>为了确保您的合法权益，请在购买学习卡前认真阅读并遵守以下条款：</p>
        <p>1、请核对您的个人信息，确保使用本人账号购卡，以防买错、绑错。</p>
        <p>2、购卡前请仔细阅读学习卡信息，自网上购卡30天内且未绑定未使用的学习卡，用户可自行点击“申请退款”进行退卡；超过30天将不予退卡。</p>
        <p>3、学习卡绑定账户后方可申请发票（购买之日起30天内），申请后可在“发票中心”查看详情。节假日期间申请发票，将于节后2-3个工作日可下载发票。</p>
        <p>4、因发票错填补开周期较长，请您确保开票信息正确。如有其他开票问题，欢迎电话咨询：010-83116339。</p>
      </div>
    </el-dialog>
    <el-dialog title="学分卡购买须知及使用说明"
               width="560px"
               :visible.sync="isShuomingBox">
      <div class="xieyiBox">
        <p>
          全科医学继续教育网络学院是由全科医学网与举名继续教育网联合创建的专注于全科医学领域的网络继续教育培训平台（以下简称“此平台”），用户在此平台可实现订阅课程、学习、考核、学分申请等全流程CME课程的闭环管理。
        </p>
        <h4>一、个人用户学习路径</h4>
        <p>
          个人用户可通过全科医学网-全科知家-CME课程购买学习卡并补全学分相关信息；课程支付过程可使用学习卡兑换，也可通过微信、支付宝等进行在线支付。购买成功后，从全科知家跳转https://cgpcme.com平台学习；进行课程订阅、学习、考核并申请学分。
        </p>
        <p>1.1学习卡购买及使用流程</p>
        <p>第一步：登录“全科医学网”，点击头像进入“个人中心”→“全科知家”→“学习卡购买”，选择您所需要的学习卡类别点击“购买”并补全学分相关信息→阅读并勾选《学分购买协议》→“支付”；</p>
        <p>第二步：在支付页面，请选择您将使用的支付方式，按提示进行付款；</p>
        <p>第三步：付款成功后，点击“购课记录”，即可查看已购买的学习卡订单；</p>
        <p>第四步：在学习卡订单中，点击“选课”按钮，跳转平台订阅课程并学习→学习完成→考核→学分上传。</p>
        <p>1.2直接登录https://cgpcme.com平台购买学习的选课方式</p>
        <p>选择学分类别和分值，选择课程并补全学分相关信息→开始学习(订阅课程)→支付（免费课程跨过此步骤）→学习完成→考核→申请学分→学分上传。</p>
        <h4>二、机构学员学习路径</h4>
        <p>机构学员学习卡及学习项目是由机构管理员自动绑定并推送课程至个人账号，并在“个人中心”-“我的课程”-“CME课程”进行学习。</p>
        <p>推送的课程为已订阅已支付状态，个人用户可点击“开始学习”跳转https://cgpcme.com平台进行课程学习、考核、学分申请。</p>
        <p>除全科知家已绑定的课程外，机构用户还可直接在https://cgpcme.com平台订阅其他课程，订阅学习流程与个人用户一致。</p>
      </div>
    </el-dialog>
    <div class="paymentcover"
         v-show="ZomCover">
      <div class="paymentcover_main">
        <div class="paymentcover_close"
             @click="ZomClose()">
          <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="payment_body"
             v-show="Paymentgote">
          <div class="PayCont_body_notice">
            <span>选择支付方式</span>
          </div>
          <div class="PayMethods">
            <p>订单号：{{ ordernum }}</p>
            <div class="PayMethods_list">
              <li>
                <el-radio v-model="radio"
                          label="1">
                  <i class="iconfont icon-weixin1"></i>
                  <span>微信</span>
                </el-radio>
              </li>
              <li>
                <el-radio v-model="radio"
                          label="2">
                  <i class="iconfont icon-umidd17"></i>
                  <span>支付宝</span>
                </el-radio>
              </li>
            </div>
          </div>
          <div class="paysubmit"
               @click="paySubmit">确定</div>
        </div>
        <div class="payment_body"
             v-show="PaymentCode">
          <div class="PayMethods"
               style="border-top:none;margin-top:0px;">
            <p>学分卡购买</p>
          </div>
          <div class="PayMethods"
               style="border-top:none;margin-top:0px;">
            <p>支付金额：{{ payInfo ? payInfo.cardPrice * buynum : 0 }} 元</p>
          </div>
          <div class="PayMethods"
               style="border-top:none;margin-top:0px;">
            <p>商品订单：{{ ordernum }}</p>
          </div>
          <!-- 付款二维码 -->
          <div class="PayCont_body_PayCode"
               v-loading="isloading"
               id="wxpay"></div>
        </div>
      </div>
    </div>
    <upUserInfo :isShow="isUserInfoBox"
                :info="userInfo"
                @togo="toUserGo"
                @close="isUserInfoBox = false"></upUserInfo>
    <el-dialog title="购课记录"
               :visible.sync="isRecordBox"
               width="600px">
      <el-table :data="RecordBoxList"
                height="300px"
                style="width: 100%">
        <el-table-column prop="title"
                         label="项目名称"> </el-table-column>
        <el-table-column prop="category"
                         label="项目类别"> </el-table-column>
        <el-table-column prop="scoreCategory"
                         label="学分分类"> </el-table-column>
        <el-table-column prop="score"
                         label="消耗学分"> </el-table-column>
        <el-table-column prop="creadate"
                         label="兑换时间"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import upUserInfo from '../../components/upUserInfo/index.vue';
export default {
  components: {
    upUserInfo
  },
  data () {
    return {
      pageType: 1, //1-购买，2-记录，3-激活
      isBuyBox: false,
      buynum: 1,
      page: {
        total: 0,
        pageSize: 6,
        currentPage: 1
      },
      recordList: [],
      checked: false,
      ispaying: false,
      list: [],
      AuthorId: 0,
      payInfo: null,
      ZomCover: false,
      ordernum: '',
      radio: '',
      Paymentgote: true,
      PaymentCode: false,
      isloading: true,
      timer: null,
      isXieyiBox: false,
      isShuomingBox: false,
      isUserInfoBox: false,
      userInfo: null,
      recordType: 0,
      recordTypeList: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '已使用'
        },
        {
          value: 2,
          label: '未使用'
        }
      ],
      isRecordBox: false,
      RecordBoxList: [],
      active: {
        text: '',
        word: ''
      },
      isActive: false
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = Number(JSON.parse(localStorage.getItem('ResData')).id);
      this.getList();
    }
    if (this.$route.query.type && this.$route.query.type == 2) {
      this.pageType = 2;
    }
  },
  watch: {
    pageType (type) {
      if (type == 2) {
        this.getRecordList();
      }
    }
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return;
      this.page.currentPage = val;
      this.getRecordList();
    },
    recordTypeChange () {
      this.page.currentPage = 1;
      this.getRecordList();
    },
    getList () {
      this.httphelper.get('/api/LearnProjectApi/GetLearCardShoppList').then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    getRecordList () {
      this.httphelper
        .get('/api/LearnProjectApi/GetUserCardPagelist', {
          userId: this.AuthorId,
          status: this.recordType,
          page: this.page.currentPage,
          limit: 10
        })
        .then(res => {
          if (res.code == 200) {
            this.recordList = res.data;
            this.page.total = res.totalcount;
          }
        });
    },
    toList () {
      this.pageType = 2;
    },
    tobuy (data) {
      this.payInfo = data;
      this.getUserInfo();
    },
    topay () {
      if (!this.checked) {
        this.$message({
          message: '请阅读并勾选《学分购买协议》！',
          type: 'warning'
        });
        return;
      }
      this.ispaying = true;
      this.httphelper
        .post('/api/CGpPayApi/CardPayOrderNumber', {
          userId: this.AuthorId,
          cardId: this.payInfo.id,
          count: this.buynum
        })
        .then(res => {
          if (res.data.code == 200) {
            this.ispaying = false;
            this.ordernum = res.data.data;
            this.isBuyBox = false;
            this.ZomCover = true;
          } else if (res.data.code == 205) {
            this.$message.error('库存不足，请稍后再试！');
          } else if (res.data.code == 206) {
            this.$message.error('身份信息错误，请核实后再试！');
          } else {
            this.$message.error('系统错误，请稍后再试！');
          }
        });
    },
    // 提交支付
    paySubmit () {
      if (this.radio == false) {
        this.$message({
          message: '请选择付费方式',
          type: 'warning'
        });
      } else {
        this.isloading = true;
        this.httphelper
          .post('/api/CGpPayApi/OrderNumberPayment', {
            orderNumber: this.ordernum,
            userId: this.AuthorId,
            payWay: Number(this.radio),
            spBillCreateIp: localStorage.getItem('Ip'),
            paymethod: this.radio == 1 ? 1 : 4,
            code: '150'
          })
          .then(res => {
            if (res.data.code == 200) {
              if (this.radio == 1) {
                this.Paymentgote = false;
                this.PaymentCode = true;
                var qrcode = new QRCode(document.getElementById('wxpay'), {
                  width: 150,
                  height: 150
                });
                qrcode.makeCode(res.data.data.qrCodeUrl);
                this.isloading = false;
                this.wxOrderNumber = res.data.data.outTradeNo;
                this.timer = setInterval(() => {
                  this.WxPayOK();
                }, 3000);
              } else if (this.radio == 2) {
                this.Paymentgote = false;
                this.PaymentCode = true;
                const div = document.createElement('iframe');
                const wxcode = document.getElementById('wxpay');
                div.srcdoc = res.data.data.responseBody;
                div.style = 'width:150px;overflow: hidden;';
                div.marginwidth = '0';
                div.framespacing = '0';
                div.marginheight = '0';
                div.setAttribute('frameborder', 'no');
                div.scrolling = 'no';
                div.onload = () => {
                  this.isloading = false;
                };
                wxcode.appendChild(div);
                this.wxOrderNumber = res.data.data.outTradeNo;
                this.timer = setInterval(() => {
                  this.WxPayOK();
                }, 3000);
              }
            } else if (res.data.code == 205) {
              this.$message({
                message: '此订单已失效',
                type: 'warning'
              });
            } else if (res.data.code == 201) {
              this.$message({
                message: '此订单已付款，请确认订单',
                type: 'warning'
              });
            }
          });
      }
    },
    WxPayOK () {
      this.httphelper
        .post('/api/CGpPayApi/WeChatVer', {
          ordernumber: this.wxOrderNumber
        })
        .then(res => {
          if (res.data.code == 200) {
            clearInterval(this.timer);
            this.radio = '';
            this.ordernum = '';
            this.ZomCover = false;
            this.$router.push({
              name: 'userCreditsPaySuccess'
            });
          }
        });
    },
    ZomClose () {
      this.radio = '';
      this.ordernum = '';
      this.ZomCover = false;
    },
    getUserInfo () {
      this.httphelper
        .post('/api/CGpUserApi/GetUserMessage', {
          id: this.AuthorId
        })
        .then(res => {
          if (res.data.code == 200) {
            let info = res.data.data;
            if (
              info.userName &&
              info.mobile &&
              info.unit &&
              info.iDcard &&
              info.province &&
              info.userName != null &&
              info.mobile != null &&
              info.unit != null &&
              info.iDcard != null &&
              info.province != null
            ) {
              this.isBuyBox = true;
            } else {
              this.userInfo = info;
              this.isUserInfoBox = true;
            }
          }
        });
    },
    toShowRecord (e) {
      this.httphelper
        .get('/api/LearnProjectApi/GetCardconvertrecord', {
          num: e.num
        })
        .then(res => {
          if (res.code == 200) {
            this.RecordBoxList = res.data;
          }
        });
      this.isRecordBox = true;
    },
    toCourseList () {
      this.httphelper
        .get('/api/LearnProjectApi/GetUserCardPagelist', {
          userId: this.AuthorId,
          status: 0,
          page: 1,
          limit: 10
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              if (this.$cookies.get('token_chinagp')) {
                window.open('https://www.jumingedu.com/qkyx/course?token=' + this.$cookies.get('token_chinagp'), '_blank');
              } else {
                window.open('https://www.jumingedu.com/qkyx/course', '_blank');
              }
            } else {
              this.$message.error('请先购买学分卡！');
            }
          }
        });
    },
    toActive () {
      if (this.active.text == '' || this.active.word == '') {
        return this.$message.error('卡号卡密不能为空');
      }
      this.isActive = true;
      this.httphelper
        .post('/api/CGpUserApi/GetUserMessage', {
          id: this.AuthorId
        })
        .then(res => {
          if (res.data.code == 200) {
            let info = res.data.data;
            if (
              info.userName &&
              info.mobile &&
              info.unit &&
              info.iDcard &&
              info.province &&
              info.userName != null &&
              info.mobile != null &&
              info.unit != null &&
              info.iDcard != null &&
              info.province != null
            ) {
              this.toActive2();
            } else {
              this.isActive = false;
              this.userInfo = info;
              this.isUserInfoBox = true;
            }
          }
        });
    },
    toActive2 () {
      this.httphelper
        .post('/api/LearnProjectApi/LearCardactivate', {
          userId: this.AuthorId,
          num: this.active.text,
          pwd: this.active.word
        })
        .then(res => {
          this.isActive = false;
          this.active.text = '';
          this.active.word = '';
          if (res.data.code == 200) {
            this.$message({
              message: '学分卡激活成功',
              type: 'success'
            });
            this.pageType = 2;
          } else if (res.data.code == 205) {
            this.$message.error('学习卡不存在');
          } else if (res.data.code == 206) {
            this.$message.error('请完善个人信息');
          } else if (res.data.code == 207) {
            this.$message.error('学习卡卡密错误');
          } else if (res.data.code == 208) {
            this.$message.error('学习卡已被使用');
          } else {
            this.$message.error('激活失败');
          }
        });
    },
    toUserGo () {
      this.isUserInfoBox = false;
      if ((this.pageType = 3)) {
        this.toActive2();
      } else {
        this.isBuyBox = true;
      }
    }
  },
  destroyed () {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.top {
    width: 100%;
    height: 200px;
    background-color: #eee;
    margin: 20px 0;
    img {
        width: 100%;
        height: 200px;
    }
}
.mid {
    .mtop {
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .mtleft {
            font-size: 15px;
            line-height: 15px;
        }
        .mtright {
            display: flex;
            .mtrbox {
                // width: 80px;
                height: 28px;
                padding: 0 16px;
                border-radius: 20px;
                font-size: 14px;
                line-height: 28px;
                border: 1px solid #0b8586;
                color: #0b8586;
                text-align: center;
                margin-left: 20px;
                cursor: pointer;
            }
        }
    }
    .mbox {
        .mtable {
            width: 973px;
            ::v-deep thead {
                th {
                    background-color: #0b8586 !important;
                    color: #fff;
                }
            }
        }
        .courseBox {
            width: 100%;
            height: 190px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 0;
            box-sizing: border-box;
            border-top: 5px solid #f8f8f8;
            .cleft {
                width: auto;
                height: 100%;
                display: flex;
                align-items: center;
                .imgBox {
                    width: 250px;
                    height: 100%;
                    img {
                        width: 250px;
                        height: 100%;
                    }
                }
                .infoBox {
                    width: auto;
                    height: 100%;
                    margin-left: 30px;
                    padding-top: 5px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .title {
                        font-size: 16px;
                        color: #333;
                    }
                    .remake {
                        font-size: 14px;
                        color: #333;
                        line-height: 30px;
                    }
                }
            }
            .cright {
                height: 100%;
                padding: 5px 0 6px 0;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .schedules {
                    font-size: 14px;
                    color: #217473;
                    text-align: right;
                }
                .btnArr {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .statusOne {
                        background-color: #b70109;
                        color: #fff;
                        cursor: pointer;
                        width: 80px;
                        height: 26px;
                        box-sizing: border-box;
                        text-align: center;
                        line-height: 26px;
                        font-size: 12px;
                        border-radius: 14px;
                        margin-top: 10px;
                    }
                }
            }
        }
        .active {
            margin-top: 20px;
            display: flex;
            align-items: center;
            ::v-deep .el-input {
                width: 348px;
                margin-right: 40px;
            }
            ::v-deep .el-button {
                width: 100px;
                background-color: #0b8586;
            }
        }
    }
}
.buybox {
    .bbrow {
        display: flex;
        align-items: center;
        height: 50px;
        .bbtext {
            width: 100px;
            margin-right: 30px;
            text-align: right;
        }
        .bbtip {
            margin-left: 30px;
            color: #b70109;
            cursor: pointer;
        }
    }
    .bbagreement {
        justify-content: flex-end;
        font-size: 13px;
        line-height: 16px;
    }
    .bbbtn {
        justify-content: center;
        height: 30px;
        button {
            background-color: #0b8586;
            color: #fff;
        }
    }
}
.paymentcover {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(000, 000, 000, 0.3);
    z-index: 999;
    left: 0;
    top: 0;
    .paymentcover_main {
        width: 572px;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        .paymentcover_close {
            width: 100%;
            height: 20px;
            text-align: right;
            line-height: 20px;
            position: relative;
            i {
                color: #ffffff;
                position: absolute;
                font-size: 35px;
                cursor: pointer;
                -webkit-transition: -webkit-transform 0.5s ease-out;
                -moz-transition: -moz-transform 0.5s ease-out;
                transition: transform 0.5s ease-out;
                font-weight: bold;
            }
            i:hover {
                -webkit-transform: rotate(360deg);
                -moz-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }
        .payment_body {
            background: #fff;
            box-shadow: 0px 1px 30px 0px rgba(0, 0, 0, 0.5);
            border-radius: 10px;
            padding: 25px;
            padding-bottom: 25px;
            position: relative;
            .PayCont_body_notice {
                position: relative;
                line-height: 22px;
                span:nth-child(1) {
                    color: #000000;
                    font-size: 22px;
                    font-weight: bold;
                    letter-spacing: 1px;
                }
            }
            .PayMethods {
                width: 100%;
                margin-top: 15px;
                border-top: 1px solid #eee;
                padding-top: 21px;
                .PayMethods_list {
                    height: 100px;
                    background: #fafafa;
                    margin-top: 18px;
                    padding: 19px 14px;
                    li {
                        height: 50px;
                        line-height: 50px;
                        list-style: none;
                        ::v-deep .el-radio__input.is-checked .el-radio__inner {
                            border: 1px solid #c2c2c2;
                            background: #fff;
                        }
                        ::v-deep .el-radio__inner {
                            width: 12px;
                            height: 12px;
                        }
                        ::v-deep .el-radio__inner::after {
                            background: #e00019;
                        }
                        ::v-deep .el-radio__label {
                            padding-left: 32px;
                        }
                        i {
                            font-size: 26px;
                            position: relative;
                            top: 4px;
                            margin-right: 15px;
                        }
                        span {
                            color: #000;
                            font-size: 15px;
                        }
                    }
                    li:nth-child(2) {
                        i {
                            color: #07a0f8;
                            font-size: 26px;
                        }
                    }
                    li:nth-child(1) {
                        i {
                            color: #02bb29;
                            font-size: 24px;
                        }
                    }
                }
            }
            .paysubmit {
                width: 80px;
                height: 35px;
                text-align: center;
                line-height: 35px;
                border-radius: 3px;
                cursor: pointer;
                background: #23b8ff;
                border: 1px solid #23b8ff;
                color: #fff;
                margin-top: 20px;
                margin-left: 438px;
            }
        }
        .PayCont_body_PayCode {
            width: 150px;
            height: 150px;
            margin: 0 auto;
            position: relative;
            margin-top: 30px;
            padding-bottom: 25px;
            img {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
            }
            p {
                position: absolute;
                bottom: -28px;
                width: 100%;
                text-align: center;
            }
        }
    }
}
.xieyiBox {
    p {
        line-height: 25px;
        text-indent: 2em;
    }
    h4 {
        margin: 5px 0 4px;
    }
}
</style>
